<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">{{ $t('estado_pago') }}</h3>
        </b-card-header>

        <b-row class="ml-3 justify-content-start align-items-start">
            <b-col md="4">
                <b-form-group label="Empresa" label-for="empresaID">
                    <template v-slot:label>
                        {{ $t('empresa') }}
                    </template>
                    <el-select class="custom-input" v-model="filter.empresa" filterable clearable
                        :placeholder="$t('empresa')" style="width: 100%;">
                        <el-option v-for="item in empresaOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>
            <b-col md="4">
                <b-form-group label-for="orden" class="mb-0 d-flex">
                    <template v-slot:label>
                        {{ $t('ordenar_por') }}
                    </template>
                    <div>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="true" :unchecked-value="null" class="chek">
                            {{ $t('Recientes') }}
                        </b-form-checkbox>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="false" :unchecked-value="null" class="chek">
                            {{ $t('Antiguos') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        
        <b-row class="ml-3 justify-content-center align-items-center">
            <b-col v-if="rol === 'admin'" md="auto" class="text-center">
                <b-form-group style="">
                    <b-button type="submit" @click="getAllFiltered()" variant="primary"
                        style="margin-top: 0px;">
                        {{ $t('buscar') }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>

        <el-table class="table-responsive table" header-row-class-name="thead-light" :data="pagos">
            <el-table-column :label="$t('nombre')" prop="budget" min-width="80px">
                <template v-slot="{ row }">
                    <a class="status" @click="$router.push(`/ingresos/pagados/2/${row.id}`)"
                        style="cursor: pointer; color: blue; text-decoration: underline;">
                        {{ row.nombre }}
                    </a>
                </template>
            </el-table-column>

            <el-table-column :label="$t('empresa')" prop="budget" min-width="80px">
                <template v-slot="{ row }">
                    <a class="status">
                        {{ row.empresa }}
                    </a>
                </template>
            </el-table-column>

            <el-table-column :label="$t('fecha')" min-width="50px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.fecha }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('accion')" min-width="40px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <router-link :to="{ name: 'pago-detalle', params: { id: row.id } }">
                                <a variant="primary" class="btn-create-new">
                                    <i class="fas fa-eye"></i>
                                </a>
                            </router-link>
                        </b-col>
                        <b-col>
                            <a @click="deleteRow(row.id)" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>
        </el-table>

    </b-card>
</template>
<script>
import pagoService from '@/api/pagoService';
import { Table, TableColumn, Select, Option  } from 'element-ui'
import utilsService from '@/api/utilsService';
import miscService from '@/api/miscService';
export default {
    name: 'pago-table',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            pagos: [],
            empresaOptions: [],
            currentPage: 1,
            filter: {
                OrderNuevos: true,
                empresa: null
            },
        };
    },
    async beforeMount() {
        try {
            this.empresaOptions = await miscService.getEmpresasOptions();
            this.pagos = await pagoService.getAllEstados();
        } catch (error) {
            console.error('Error fetching choferes:', error);
        }
    },
    computed: {
        rol() {
            return utilsService.getRol();
        }
    },
    methods: {
        async getAllFiltered(){
            const response = await pagoService.getAllFiltered(this.filter);
            this.pagos = response;
        },
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await pagoService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }

                    this.pagos = await pagoService.getAllEstados();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
    }
}
</script>
